import { createComponent } from "@front/utils/alpine";

type TProductOption = {
    id: string;
    name: string;
    link_rewrite: string;
    id_shop: string;
};

type TBrandOption = {
    id_brand: string;
    name: string;
};

type TModelOption = {
    id_model: string;
    name: string;
};

type TProduct = {
    id_product_model: string;
    h1: string;
    description: string;
    meta_description: string;
    meta_title: string;
    url: string;
}

export default createComponent(() => ({
    selectedProduct: "default",
    productOptions: [] as TProductOption[],

    selectedBrand: "default",
    brandOptions: [] as TBrandOption[],

    selectedModel: "default",
    modelOptions: [] as TModelOption[],

    async init() {
        this.$watch('selectedProduct', async () => await this.getBrands());
        this.$watch('selectedBrand', async () => await this.getModels());
        this.$watch('selectedModel', async () => {
            const product = await this.getProduct();
            window.location.href = product.url;
        });

        const categories = await fetch('/modules/tailor/webservice/categories-ajax.php');
        this.productOptions = await categories.json();

        const category = document.getElementById('selector_category') as HTMLSelectElement;
        if (category && !!category.value) {
            this.selectedProduct = category.value;
        }
    },

    async getBrands(): Promise<void> {
        const brands = await fetch(`/modules/tailor/webservice/brands-ajax.php?id_category=${this.selectedProduct}`)
        this.brandOptions = await brands.json();

        const brand = document.getElementById('selector_brand') as HTMLSelectElement;
        if (brand && !!brand.value) {
            this.selectedBrand = brand.value;
        }
    },

    async getModels(): Promise<void> {
        const models = await fetch(`/modules/tailor/webservice/models-ajax.php?id_category=${this.selectedProduct}&id_brand=${this.selectedBrand}`);
        this.modelOptions = await models.json();
    },

    async getProduct(): Promise<TProduct> {
        const product = await fetch(`/modules/tailor/webservice/models-ajax.php?id_category=${this.selectedProduct}&id_brand=${this.selectedBrand}&id_model=${this.selectedModel}`);
        return await product.json();
    }
}));
